<template>
  <div
    v-if="$store.getters['auth/logged_in']"
    class="authNav__loggedIn"
  >
    <div v-if="false">
      <router-link :to="{ name: 'rentals', params: { id: 1 } }">
        <el-link :underline="false">{{ $t('nav.rentals') }}</el-link>
      </router-link>
    </div>
    <!-- Profile -->
    <div
      class="authNav__profile"
      :class="{selected: $route.name === 'profile' }"
    >
      <router-link :to="{ name: 'profile' }">
        <el-link :underline="false">
          <i class="el-icon-user el-icon--left"></i>{{ customer.first_name }} {{ customer.last_name }}
        </el-link>
      </router-link>
    </div>
    <!-- Records -->
    <div
      class="authNav__records"
      :class="{selected: $route.name === 'records-grid' }"
    >
      <router-link :to="{ name: 'records-grid' }">
        <el-link :underline="false">
          <i class="el-icon-folder-opened el-icon--left"></i>{{ $t('nav.records') }}
        </el-link>
      </router-link>
    </div>
    <language-picker class="authNav__languagePicker" />
    <logout-button />
  </div>
  <div
    v-else
    class="authNav__loggedOut"
  >
    <div>
      <router-link :to="{ name: 'login' }">
        <el-link :underline="false">{{$t('pageNames.login')}}</el-link>
      </router-link>
    </div>
    <language-picker class="authNav__languagePicker" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LanguagePicker from '@/components/ui/LanguagePicker'
import LogoutButton from '@/components/ui/LogoutButton'

export default {
  name: 'AuthNav',
  components: {
    LanguagePicker,
    LogoutButton
  },
  data() {
    return {
      profileMenu: false
    }
  },
  computed: {
    ...mapState({
      customer: state => state.customer
    })
  }
}
</script>

<style lang="scss" scoped>
$c: '.authNav';

#{$c} {
  &__loggedIn,
  &__loggedOut {
    display: flex;
    align-items: center;

    div {
      margin-right: 40px;
      @include respond-below(md) {
        margin-right: 10px;
      }
    }
  }

  &__profile,
  &__records {
    position: relative;

    @include respond-below(md) {
      display: none;
    }
  }

  &__profile.selected,
  &__records.selected {
    &:before {
      content: '';
      width: calc(100% - 20px);
      height: 15px;
      border-radius: 15px;
      position: absolute;
      top: 22px;
      margin-left: 30px;
      background-color: rgba($--color-primary, 0.6);
    }
  }

  &__languagePicker {
    margin: 0 10px 0 50px !important;
  }
}

.profileMenu__items {
  > a {
    display: block;
  }
  > a:not(:first-child) {
    margin-top: 12px;
  }
  .el-link {
    font-size: 14px;
    display: block;
  }
}
</style>